import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { MetricCard } from "@/components/dashboard/MetricCard";
import { HealthBadge } from "@/components/dashboard/HealthBadge";

export interface PortfolioStatusData {
  synchronizationStatus?: string | null;
  reconciliationStatus?: string | null;
  portfolioHealth?: string | null;
}

interface PortfolioStatusPanelProps {
  data: PortfolioStatusData;
}

/** Reconciliation Status has no backend read endpoint today - rendered honestly, not fabricated. */
export function PortfolioStatusPanel({ data }: PortfolioStatusPanelProps): React.JSX.Element {
  return (
    <StatusCard title="Portfolio Health">
      <Stack spacing={1.5}>
        <MetricCard
          label="Synchronization Status"
          render={<HealthBadge status={data.synchronizationStatus ?? null} />}
        />
        <MetricCard label="Reconciliation Status" value={data.reconciliationStatus} />
        <MetricCard
          label="Portfolio Health"
          render={<HealthBadge status={data.portfolioHealth ?? null} />}
        />
      </Stack>
    </StatusCard>
  );
}
